export const idleTimeDetectorLogout = ({
  inActivityDetectedHandler = () => {},
}) => {
  let sessionInterval;
  const INACTIVITY_MINUTES = 20;
  const SECONDS_IN_ONE_MINUTE = 60;
  const MILLISECONDS_IN_ONE_SECOND = 1000;

  let NET_MILLISECOND_INACTIVITY =
    INACTIVITY_MINUTES * SECONDS_IN_ONE_MINUTE * MILLISECONDS_IN_ONE_SECOND;

  // DOCS: For testing purposes, set the inactivity time to 10 seconds
  // NET_MILLISECOND_INACTIVITY = 10000;

  const resetTimer = () => {
    clearTimeout(sessionInterval);
    sessionInterval = setTimeout(
      // FIXME: Empty function so that session expired modal doesn't show up
      () => {},
      NET_MILLISECOND_INACTIVITY
    ); // time is in milliseconds
  };

  // DOCS: If any activity is detected, reset the timer
  window.onload = resetTimer;
  window.onmousemove = resetTimer;
  window.onmousedown = resetTimer; // DOCS: catches touchscreen presses as well
  window.ontouchstart = resetTimer; // DOCS: catches touchscreen swipes as well
  window.ontouchmove = resetTimer; // DOCS: required by some devices
  window.onclick = resetTimer; // DOCS: catches touchpad clicks as well
  window.onkeydown = resetTimer;
  window.addEventListener('scroll', resetTimer, true);
};
